export const LOADING_START = 'LOADING_START';
export const LOADING_SUCCESS = 'LOADING_SUCCESS';
export const Failed_Load = 'Failed_Load';
export const Screenshot_Data = 'Screenshot_Data';
export const Clear_Screenshot_Data = 'Clear_Screenshot_Data';